<template>
  <div>
    <button @click="showModal = true" class="btn-primary">
      <svg class="w-5 h-5" style="width: 1.25rem; height: 1.25rem; margin-right: 0.5rem;" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
      </svg>
      Upload Swagger
    </button>

    <!-- Modal -->
    <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">Upload Swagger/OpenAPI</h3>
          <button @click="closeModal" class="close-button">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        <div class="modal-body space-y-4">
          <div class="form-group">
            <label class="form-label">Nome da API</label>
            <input 
              v-model="apiName"
              type="text" 
              class="input-field"
              placeholder="Digite o nome da API"
            >
          </div>

          <div class="form-group">
            <label class="form-label">Arquivo Swagger (JSON/YAML)</label>
            <input 
              @change="handleFileSelect"
              type="file" 
              accept=".json,.yaml,.yml"
              class="input-field"
            >
          </div>

          <div class="form-group">
            <label class="form-label">Ou Cole o Conteúdo</label>
            <textarea 
              v-model="swaggerContent"
              class="input-field"
              placeholder="Cole aqui o conteúdo do Swagger/OpenAPI"
              rows="6"
            ></textarea>
          </div>

          <div class="flex-row gap-4">
            <button 
              @click="uploadSwagger"
              :disabled="uploading"
              class="btn-primary"
              style="flex: 1;"
            >
              {{ uploading ? 'Enviando...' : 'Upload' }}
            </button>
            <button 
              @click="closeModal"
              class="btn-secondary"
              style="flex: 1;"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { uploadSwaggerFile } from '@/services/apiOld'

const emit = defineEmits(['uploaded'])

const showModal = ref(false)
const apiName = ref('')
const swaggerContent = ref('')
const selectedFile = ref(null)
const uploading = ref(false)

const handleFileSelect = (event) => {
  selectedFile.value = event.target.files[0]
}

const uploadSwagger = async () => {
  if (!apiName.value || (!selectedFile.value && !swaggerContent.value)) {
    alert('Por favor, preencha todos os campos obrigatórios')
    return
  }

  uploading.value = true
  
  try {
    let content = swaggerContent.value
    
    if (selectedFile.value) {
      content = await readFileContent(selectedFile.value)
    }

    await uploadSwaggerFile({
      name: apiName.value,
      content: content
    })

    emit('uploaded')
    closeModal()
    alert('Swagger enviado com sucesso!')
  } catch (error) {
    console.error('Erro no upload:', error)
    alert('Erro ao enviar o arquivo. Tente novamente.')
  } finally {
    uploading.value = false
  }
}

const readFileContent = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (e) => resolve(e.target.result)
    reader.onerror = reject
    reader.readAsText(file)
  })
}

const closeModal = () => {
  showModal.value = false
  apiName.value = ''
  swaggerContent.value = ''
  selectedFile.value = null
}
</script>